import { useEffect, useMemo, useState, useCallback } from 'react';
import * as anchor from '@project-serum/anchor';

import styled from 'styled-components';
// import { Container, Snackbar } from '@material-ui/core';
// import Paper from '@material-ui/core/Paper';
// import Alert from '@material-ui/lab/Alert';
// // import Grid from '@material-ui/core/Grid';
// import Typography from '@material-ui/core/Typography';
// import web3Solana from '@solana/web3.js';
import { useWallet } from '@solana/wallet-adapter-react';
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import {
  awaitTransactionSignatureConfirmation,
  CandyMachineAccount,
  CANDY_MACHINE_PROGRAM,
  getCandyMachineState,
  mintOneToken,
  getCollectionPDA,
  SetupState,
  createAccountsForMint,
} from './candy-machine';
import { AlertState, toDate, formatNumber, getAtaForMint } from './utils';
// import { MintCountdown } from './MintCountdown';
// import { MintButton } from './MintButton';
// import { GatewayProvider } from '@civic/solana-gateway-react';
// import { sendTransaction } from './connection';
import AppModal from './AppModal';
import { Button, Row, Col, Grid } from 'antd'

import { FONT, COLOR } from './constants'
import AppLayout from './components/AppLayout';
import { BlockchainFAQ, CollectionFAQ, CollectionInfo, CollectionList, CollectionMint, ContactUs, Landing, TeamMember } from './components';
import WhitelistModal from './WhitelistModal';

const { useBreakpoint } = Grid;

const ConnectButton = styled(WalletMultiButton)`
  width: 100%;
  height: 100%;
  margin-top: 10px;
  margin-bottom: 5px;
  background: #3CE6DB;
  color: white;
  font-size: 40px;
  font-family: Orbitron;
  font-weight: bold;
`;

const ConnectButtonShow = styled(WalletMultiButton)`
  border-radius: 18px !important;
  padding: 6px 16px;
  background-color: #4E44CE;
  margin: 0 auto;
`;

const MintContainer = styled.div``; // add your owns styles here
const WalletContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: right;
`;

const WalletAmount = styled.div`
  color: black;
  width: auto;
  padding: 5px 5px 5px 16px;
  min-width: 48px;
  min-height: auto;
  border-radius: 22px;
  background-color: var(--main-text-color);
  box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%);
  box-sizing: border-box;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-weight: 500;
  line-height: 1.75;
  text-transform: uppercase;
  border: 0;
  margin: 0;
  display: inline-flex;
  outline: 0;
  position: relative;
  align-items: center;
  user-select: none;
  vertical-align: middle;
  justify-content: flex-start;
  gap: 10px;
`;

const Wallet = styled.ul`
  flex: 1;
  margin: 0;
  padding: 0;
  text-align: right;
`;
export interface HomeProps {
  candyMachineId?: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  txTimeout: number;
  rpcHost: string;
}

const Home = (props: HomeProps) => {
  const isMobile = useBreakpoint().xs;
  const [isUserMinting, setIsUserMinting] = useState(false);
  const [candyMachine, setCandyMachine] = useState<CandyMachineAccount>();
  const [alertState, setAlertState] = useState<AlertState>({
    open: false,
    message: '',
    severity: undefined,
  });

  const [isActive, setIsActive] = useState(false);
  const [endDate, setEndDate] = useState<Date>();
  const [itemsRemaining, setItemsRemaining] = useState<number>();
  const [isWhitelistUser, setIsWhitelistUser] = useState(false);
  const [isPresale, setIsPresale] = useState(false);
  const [discountPrice, setDiscountPrice] = useState<anchor.BN>();
  const [needTxnSplit, setNeedTxnSplit] = useState(true);
  const [setupTxn, setSetupTxn] = useState<SetupState>();
  const [balance, setBalance] = useState<number>();
  const [isEnded, setIsEnded] = useState(false);
  const [isSoldOut, setIsSoldOut] = useState(false);
  const [whitelistTokenBalance, setWhitelistTokenBalance] = useState(0);
  const [isWLOnly, setIsWLOnly] = useState(false);

  const [isBurnToken, setIsBurnToken] = useState(false);

  const [modalVisible, setModalVisible] = useState(false)
  const [whitelistModal, setWhitelistModal] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);
  const [userTokenAddress, setUserTokenAddress] = useState('')


  const rpcUrl = props.rpcHost;
  const wallet = useWallet();

  const anchorWallet = useMemo(() => {
    if (
      !wallet ||
      !wallet.publicKey ||
      !wallet.signAllTransactions ||
      !wallet.signTransaction
    ) {
      return;
    }

    if (wallet.disconnecting) {
      setAlertState({
        open: false,
        message: '',
        severity: undefined,
      })
      return;
    }

    if (!modalVisible) {
      setAlertState({
        open: true,
        message: 'Your wallet has been successfully connected. Stay tuned!',
        severity: 'info',
      });
    }

    return {
      publicKey: wallet.publicKey,
      signAllTransactions: wallet.signAllTransactions,
      signTransaction: wallet.signTransaction,
    } as anchor.Wallet;
  }, [wallet, modalVisible]);

  useEffect(() => {
    if (!wallet?.publicKey) {
      setBalance(0)
    }
  }, [wallet.publicKey])

  useEffect(() => {
    (async () => {
      if (anchorWallet?.publicKey?.toString()) {
        const balance = await props.connection.getBalance(anchorWallet?.publicKey);
        setBalance(balance / anchor.web3.LAMPORTS_PER_SOL);
      } else {
        setBalance(0)
      }
    })();
  }, [anchorWallet, props.connection]);


  const refreshCandyMachineState = useCallback(async () => {
    if (!anchorWallet) {
      setBalance(0)
      return;
    }

    if (props.candyMachineId) {
      try {
        const cndy = await getCandyMachineState(
          anchorWallet,
          props.candyMachineId,
          props.connection,
        );
        let active =
          cndy?.state.goLiveDate?.toNumber() < new Date().getTime() / 1000;
        let presale = false;
        // whitelist mint?
        if (cndy?.state.whitelistMintSettings) {
          // is it a presale mint?
          if (
            cndy.state.whitelistMintSettings.presale &&
            (!cndy.state.goLiveDate ||
              cndy.state.goLiveDate.toNumber() > new Date().getTime() / 1000)
          ) {
            presale = true;
          }
          setIsBurnToken(cndy.state.whitelistMintSettings.mode.burnEveryTime);
          setIsWLOnly(!cndy.state.whitelistMintSettings.presale && cndy.state.whitelistMintSettings.discountPrice === null);

          // is there a discount?
          if (cndy.state.whitelistMintSettings.discountPrice) {
            setDiscountPrice(cndy.state.whitelistMintSettings.discountPrice);
          } else {
            setDiscountPrice(undefined);
            // when presale=false and discountPrice=null, mint is restricted
            // to whitelist users only
            if (!cndy.state.whitelistMintSettings.presale) {
              cndy.state.isWhitelistOnly = true;
            }
          }
          // retrieves the whitelist token
          const mint = new anchor.web3.PublicKey(
            cndy.state.whitelistMintSettings.mint,
          );
          const token = (await getAtaForMint(mint, anchorWallet.publicKey))[0];

          try {
            const balance = await props.connection.getTokenAccountBalance(
              token,
            );
            let valid = parseInt(balance.value.amount) > 0;
            // only whitelist the user if the balance > 0
            setIsWhitelistUser(valid);
            active = (presale && valid) || active;

            setWhitelistTokenBalance(parseInt(balance.value.amount));
          } catch (e) {
            setIsWhitelistUser(false);
            // no whitelist user, no mint
            if (cndy.state.isWhitelistOnly) {
              active = false;
            }
            console.log('There was a problem fetching whitelist token balance');
            console.log(e);
          }
        }
        // datetime to stop the mint?
        if (cndy?.state.endSettings?.endSettingType.date) {
          setEndDate(toDate(cndy.state.endSettings.number));
          if (
            cndy.state.endSettings.number.toNumber() <
            new Date().getTime() / 1000
          ) {
            setIsEnded(true);
            active = false;
          }
        }
        // amount to stop the mint?
        if (cndy?.state.endSettings?.endSettingType.amount) {
          let limit = Math.min(
            cndy.state.endSettings.number.toNumber(),
            cndy.state.itemsAvailable,
          );
          if (cndy.state.itemsRedeemed < limit) {
            setItemsRemaining(limit - cndy.state.itemsRedeemed);
          } else {
            setItemsRemaining(0);
            cndy.state.isSoldOut = true;
            setIsEnded(true);
          }
        } else {
          setItemsRemaining(cndy.state.itemsRemaining);
        }

        if (cndy.state.isSoldOut) {
          active = false;
        }

        const [collectionPDA] = await getCollectionPDA(props.candyMachineId);
        const collectionPDAAccount =
          await cndy.program.provider.connection.getAccountInfo(collectionPDA);

        setIsActive((cndy.state.isActive = active));
        setIsPresale((cndy.state.isPresale = presale));
        setCandyMachine(cndy);

        const txnEstimate =
          892 +
          (!!collectionPDAAccount && cndy.state.retainAuthority ? 182 : 0) +
          (cndy.state.tokenMint ? 177 : 0) +
          (cndy.state.whitelistMintSettings ? 33 : 0) +
          (cndy.state.whitelistMintSettings?.mode?.burnEveryTime ? 145 : 0) +
          (cndy.state.gatekeeper ? 33 : 0) +
          (cndy.state.gatekeeper?.expireOnUse ? 66 : 0);

        setNeedTxnSplit(txnEstimate > 1230);
      } catch (e) {
        if (e instanceof Error) {
          if (e.message === `Account does not exist ${props.candyMachineId}`) {
            setAlertState({
              open: true,
              message: `Couldn't fetch candy machine state from candy machine with address: ${props.candyMachineId}, using rpc: ${props.rpcHost}! You probably typed the REACT_APP_CANDY_MACHINE_ID value in wrong in your .env file, or you are using the wrong RPC!`,
              severity: 'error',
              noHide: true,
            });
          } else if (e.message.startsWith('failed to get info about account')) {
            setAlertState({
              open: true,
              message: `Couldn't fetch candy machine state with rpc: ${props.rpcHost}! This probably means you have an issue with the REACT_APP_SOLANA_RPC_HOST value in your .env file, or you are not using a custom RPC!`,
              severity: 'error',
              noHide: true,
            });
          }
        } else {
          setAlertState({
            open: true,
            message: `${e}`,
            severity: 'error',
            noHide: true,
          });
        }
        console.log(e);
      }
    } else {
      setAlertState({
        open: true,
        message: `Your REACT_APP_CANDY_MACHINE_ID value in the .env file doesn't look right! Make sure you enter it in as plain base-58 address!`,
        severity: 'error',
        noHide: true,
      });
    }
  }, [anchorWallet, props.candyMachineId, props.connection, props.rpcHost]);

  useEffect(() => {
    refreshCandyMachineState();
  }, [
    anchorWallet,
    props.candyMachineId,
    props.connection,
    refreshCandyMachineState,
  ]);


  const onMint = async (
    beforeTransactions: anchor.web3.Transaction[] = [],
    afterTransactions: anchor.web3.Transaction[] = [],
  ) => {
    try {
      setIsUserMinting(true);
      document.getElementById('#identity')?.click();
      if (wallet.connected && candyMachine?.program && wallet.publicKey) {
        let setupMint: SetupState | undefined;
        if (needTxnSplit && setupTxn === undefined) {
          setAlertState({
            open: true,
            message: 'Please sign account setup transaction',
            severity: 'info',
          });
          setupMint = await createAccountsForMint(
            candyMachine,
            wallet.publicKey,
          );
          console.log('setupMint', setupMint.userTokenAccount.toString());
          setUserTokenAddress(setupMint.userTokenAccount.toString())
          let status: any = { err: true };
          if (setupMint.transaction) {
            status = await awaitTransactionSignatureConfirmation(
              setupMint.transaction,
              props.txTimeout,
              props.connection,
              true,
            );
          }
          if (status && !status.err) {
            setSetupTxn(setupMint);
            setAlertState({
              open: true,
              message:
                'Setup transaction succeeded! Please sign minting transaction',
              severity: 'info',
            });
          } else {
            setAlertState({
              open: true,
              message: 'Mint failed! Please try again!',
              severity: 'error',
            });
            setIsUserMinting(false);
            return;
          }
        } else {
          setAlertState({
            open: true,
            message: 'Please sign minting transaction',
            severity: 'info',
          });
        }

        let mintOne = await mintOneToken(
          candyMachine,
          wallet.publicKey,
          beforeTransactions,
          afterTransactions,
          setupMint ?? setupTxn,
        );
        const mintTxId = mintOne[0];

        let status: any = { err: true };
        if (mintTxId) {
          status = await awaitTransactionSignatureConfirmation(
            mintTxId,
            props.txTimeout,
            props.connection,
            true,
          );
        }

        if (status && !status.err) {
          // manual update since the refresh might not detect
          // the change immediately
          let remaining = itemsRemaining! - 1;
          setItemsRemaining(remaining);
          setIsSoldOut(remaining === 0);
          setIsActive((candyMachine.state.isActive = remaining > 0));
          candyMachine.state.isSoldOut = remaining === 0;
          if (isBurnToken && whitelistTokenBalance && whitelistTokenBalance > 0) {
            let balance = whitelistTokenBalance - 1;
            setWhitelistTokenBalance(balance);

          }

          setSetupTxn(undefined);
          setAlertState({
            open: true,
            message: 'Congratulations! Mint succeeded!',
            severity: 'success',
          });
        } else {
          setAlertState({
            open: true,
            message: 'Mint failed! Please try again!',
            severity: 'error',
          });
        }
      }
    } catch (error: any) {
      let message = error.msg || 'Minting failed! Please try again!';
      if (!error.msg) {
        if (!error.message) {
          message = 'Transaction timeout! Please try again.';
        } else if (error.message.indexOf('0x137')) {
          console.log(error);
          message = `SOLD OUT!`;
        } else if (error.message.indexOf('0x135')) {
          message = `Insufficient funds to mint. Please fund your wallet.`;
        }
      } else {
        if (error.code === 311) {
          console.log(error);
          message = `SOLD OUT!`;
          window.location.reload();
        } else if (error.code === 312) {
          message = `Minting period hasn't started yet.`;
        }
      }

      setAlertState({
        open: true,
        message,
        severity: 'error',
      });
      // updates the candy machine state to reflect the latest
      // information on chain
      refreshCandyMachineState();
    } finally {
      setIsUserMinting(false);
    }
  };

  return (
    <AppLayout>
      <section id="landing" style={{ background: COLOR.primary }}>
        <Landing setWhitelistModal={setWhitelistModal} whitelistModal={whitelistModal} />
      </section>
      <section id="collection-mint" className='anchor' style={{ background: COLOR.background }}>
        <CollectionMint
          // candyMachine={candyMachine}
          // balance={balance}
          setModalVisible={setModalVisible}
        // modalVisible={modalVisible}
        // // wallet={anchorWallet || null}
        // rpcUrl={rpcUrl}
        // isMinting={isUserMinting}
        // isActive={isActive || (isPresale && isWhitelistUser)}
        // isEnded={isEnded}
        // isSoldOut={isSoldOut}
        // startMint={onMint}
        // alertState={alertState}
        // whitelistTokenBalance={whitelistTokenBalance}
        // isWLOnly={isWLOnly}
        // setAlertState={setAlertState}
        // setIsMinting={setIsUserMinting}
        // connection={props.connection}
        />
      </section>
      <section id="collection-list" className='anchor' style={{ background: '#FFF0D2' }}>
        <CollectionList />
      </section>
      <section id="collection-info" className='anchor' style={{ background: COLOR.primary }}>
        <CollectionInfo />
      </section>
      <section id="blockchain-faq" className='anchor' style={{ background: COLOR.menuText }}>
        <BlockchainFAQ />
      </section>
      <section id="collection-faq" className='anchor' style={{ background: COLOR.background }}>
        <CollectionFAQ />
      </section>
      <section id="team-member" className='anchor' style={{ background: COLOR.primary }}>
        <TeamMember />
      </section>
      <section id="contact-us" className='anchor' style={{ background: COLOR.secondary }}>
        <ContactUs setWhitelistModal={setWhitelistModal}  setFormSuccess={setFormSuccess} />
      </section>

      <AppModal
        candyMachine={candyMachine}
        balance={balance}
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        // wallet={anchorWallet || null}
        rpcUrl={rpcUrl}
        isMinting={isUserMinting}
        isActive={isActive || (isPresale && isWhitelistUser)}
        isEnded={isEnded}
        isSoldOut={isSoldOut}
        startMint={onMint}
        alertState={alertState}
        whitelistTokenBalance={whitelistTokenBalance}
        isWLOnly={isWLOnly}
        setAlertState={setAlertState}
        setIsMinting={setIsUserMinting}
        connection={props.connection}
        userTokenAddress={userTokenAddress}
      />
      <WhitelistModal setFormSuccess={setFormSuccess} formSuccess={formSuccess} setVisible={setWhitelistModal} visible={whitelistModal} />
    </AppLayout >
  )
};

const getCountdownDate = (
  candyMachine: CandyMachineAccount,
): Date | undefined => {
  if (
    candyMachine.state.isActive &&
    candyMachine.state.endSettings?.endSettingType.date
  ) {
    return toDate(candyMachine.state.endSettings.number);
  }

  return toDate(
    candyMachine.state.goLiveDate
      ? candyMachine.state.goLiveDate
      : candyMachine.state.isPresale
        ? new anchor.BN(new Date().getTime() / 1000)
        : undefined,
  );
};

const styles = {
  btn: {
    backgroundColor: '#3CE6DB', height: '100%', width: '100%', borderRadius: 12, fontSize: 20, color: '#fff', fontWeight: 'bold',
    fontFamily: 'Orbitron'
  },
  successBtn: {
    minHeight: 70, width: '100%', borderRadius: 12, fontSize: 20, color: '#fff', fontWeight: 'bold',
    fontFamily: 'Orbitron',
    background: 'linear-gradient(95.97deg, #BD7AEF 3.45%, #BD7AEF 26.67%, #E9A5D4 53.2%, #D390E2 78.62%, #BD7AEF 104.05%)'

  }
}

export default Home;